import {
  HTMLAttributes,
  TableHTMLAttributes,
  TdHTMLAttributes,
  ThHTMLAttributes,
} from "react";

import { clsx } from "clsx";
import { Button } from "./Button";

interface MiniTablePaginationProps {
  totalRows: number;
  totalPages: number;
  currentPage: number;
  itemsPerPage: number;
  onNextClick: () => void;
  onPrevClick: () => void;
}

// BASE TABLE

const MiniTable = ({
  children,
  className,
  ...rest
}: TableHTMLAttributes<HTMLTableElement>) => {
  return (
    <table
      className={clsx(
        "table border text-center border-orange-300 w-full divide-y divide-orange-300",
        className
      )}
      {...rest}
    >
      {children}
    </table>
  );
};

// END BASE TABLE

// HEADER

MiniTable.Header = ({
  children,
  className,
  ...rest
}: HTMLAttributes<HTMLTableRowElement>) => {
  return (
    <thead>
      <tr
        className={clsx("divide-x divide-orange-300 bg-orange-100", className)}
        {...rest}
      >
        {children}
      </tr>
    </thead>
  );
};

MiniTable.HeaderCell = ({
  children,
  className,
  ...rest
}: ThHTMLAttributes<HTMLTableCellElement>) => {
  return (
    <th
      className={clsx(
        "px-1.5 py-1.5 text-left text-sm font-semibold",
        className
      )}
      {...rest}
    >
      {children}
    </th>
  );
};

// END HEADER

// BODY

MiniTable.Body = ({
  children,
  className,
  ...rest
}: HTMLAttributes<HTMLTableSectionElement>) => {
  return (
    <tbody className={clsx("divide-y divide-orange-300", className)} {...rest}>
      {children}
    </tbody>
  );
};

MiniTable.Row = ({
  children,
  className,
  ...rest
}: HTMLAttributes<HTMLTableRowElement>) => {
  return (
    <tr className={clsx("divide-x divide-orange-300", className)} {...rest}>
      {children}
    </tr>
  );
};

MiniTable.Cell = ({
  children,
  className,
  ...rest
}: TdHTMLAttributes<HTMLTableCellElement>) => {
  return (
    <td
      className={clsx(
        "text-left whitespace-nowrap px-1.5 py-2 text-sm",
        className
      )}
      {...rest}
    >
      {children}
    </td>
  );
};

MiniTable.Pagination = ({
  totalRows,
  currentPage,
  totalPages: numPages,
  itemsPerPage,
  onNextClick: onNext,
  onPrevClick: onPrev,
}: MiniTablePaginationProps) => {
  return (
    <div className="mt-4 flex items-center justify-between">
      <p className="text-sm text-gray-500 italic">
        {totalRows} Records - Showing {itemsPerPage} per page
      </p>
      <div className="flex items-center space-x-2">
        <Button size="sm" onClick={onPrev}>
          {"<"}
        </Button>
        <Button size="sm" onClick={onNext}>
          {">"}
        </Button>
      </div>
      <p className="text-sm text-gray-500 italic">
        Page {currentPage} / {numPages}
      </p>
    </div>
  );
};

// END BODY

export default MiniTable;
